import { useCallback, useEffect, useState } from 'react';
import useAgent from './useAgent';

const usePaginatedAgent = (agent) => {
  const [paginatedData, setPaginatedData] = useState();

  const [fetchData, data, isFetchingData] = useAgent(agent);

  useEffect(() => {
    if (data) setPaginatedData((oldData) => (oldData ? [...oldData, ...data] : data));
  }, [data]);

  const call = useCallback(
    (...params) => {
      const callParams = params[params.length - 1];
      if (!callParams || !callParams.skip) setPaginatedData(undefined);
      return fetchData(...params);
    },
    [fetchData]
  );

  return [call, paginatedData, isFetchingData];
};

export default usePaginatedAgent;
